import CloseIcon from '@mui/icons-material/Close'
import { Box, Button, Collapse, Divider, IconButton, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import { type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import ControlPointDuplicateIcon from '@mui/icons-material/ControlPointDuplicate';

interface Props {
  selectedCount: number
  totalMatchingCount: number
  selectAllActive?: boolean
  onClear: () => void
  onSelectAll?: () => void
  actions: ReactNode
}

export default function BatchSelectionActionBar(props: Props) {
  const [t] = useTranslation('account-v2')
  const theme = useTheme()
  const breakpointLgDown = useMediaQuery(theme.breakpoints.down('lg'))

  return <Box
    component="div"
    sx={{
      boxSizing: 'border-box',
      position: 'sticky',
      top: {
        xs: '62px',
        md: '74px',
      },
      zIndex: 300,
    }}
  >
    <Collapse in={props.selectedCount > 0} timeout={250}>
      <Box
        component="div"
        sx={{
          opacity: props.selectedCount > 0 ? 1 : 0,
          transition: 'opacity 250ms ease',
          pb: 2,
        }}
      >
        <Stack
          direction={{
            xs: 'column',
            md: 'row',
          }}
          spacing={{
            xs: 0,
            md: 2
          }}
          sx={{
            alignItems: {
              xs: 'stretch',
              md: 'center',
            },
            backgroundColor: '#e0e0e0',
            border: '1px solid rgba(0, 0, 0, 0.08)',
            borderRadius: {
              xs: 1,
              md: 5,
            },
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          }}
          justifyContent="space-between"
          divider={breakpointLgDown ? <Divider /> : null}
        >
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            sx={{
              justifyContent: {
                xs: 'space-between',
                md: 'flex-start',
              },
            }}
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <IconButton
                onClick={props.onClear}
                aria-label={t('Clear selection')}
              ><CloseIcon /></IconButton>
              <Typography variant="body2" color="primary.main" sx={{ fontWeight: 500 }}>
                {props.selectAllActive
                  ? t('{{count}} matching results selected', { count: props.selectedCount })
                  : t('{{count}} selected', { count: props.selectedCount })}
              </Typography>
            </Stack>
            {(props.totalMatchingCount > props.selectedCount) && props.onSelectAll ? <Button
              size="small"
              color="secondary"
              onClick={props.onSelectAll}
              startIcon={<ControlPointDuplicateIcon />}
            >{breakpointLgDown
              ? t('Select all {{count}}', { count: props.totalMatchingCount })
              : t('Select all {{count}} matching results', { count: props.totalMatchingCount })}</Button> : null}
          </Stack>

          <Stack direction="row" alignItems="center" justifyContent="flex-end">
            {props.actions}
          </Stack>
        </Stack>
      </Box>
    </Collapse>
  </Box>
}
